import React, { useContext } from "react";
import SectionCard from "../../profiles/SectionCard";
import GallerySection from "../../profiles/GallerySection";
import { OverviewCard, RetailCard, ManufacturingCard } from "./detail_cards";
import { ProductContext } from "../data/product_context_management";

// The main column as a vertical stack of shared <SectionCard>s, in the designed order: Overview
// (the merged description/facts card), the supporting-images Gallery, Specifications, then Retail
// and Manufacturing. Every card renders only when it has content — an editor whose Specifications
// are off or empty gets the header's Add-a-section affordance instead of an empty card (see
// canAddSpecifications in the provider); Gallery self-collapses the same way when the product
// carries no supporting images. The pen ids are the ones the edit modals have always used, so each
// card still opens its own modal; the detail cards are show-side only.
function ProductSections() {
  const { product, viewerContext, showSpecifications, setOpenEditModal } = useContext(ProductContext);

  const editable = !!viewerContext?.editable;

  return (
    <div className="container-fluid px-0">
      <OverviewCard />

      <GallerySection id="product-section-gallery" title="Assets" images={product.supporting_images} />

      {showSpecifications && (
        <SectionCard
          id="product-section-specifications"
          title="Specifications"
          editable={editable}
          onEdit={() => setOpenEditModal("SPECIFICATIONS")}
          editButtonId="modal-button-specifications"
        >
          <div className="paragraph-md text-break" style={{ whiteSpace: "pre-wrap" }}>
            {product.subtype_attributes.specifications}
          </div>
        </SectionCard>
      )}

      <RetailCard />

      <ManufacturingCard />
    </div>
  );
}

export default ProductSections;
